// Main data fetch for the {attachments} macro. Fetches page-level permissions,
// DSP flag, and up to 500 attachments with metadata, labels, and operations.

import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const USE_ATTACHMENTS_MACRO_DATA_QUERY: GraphQLTaggedNode = graphql`
	query useAttachmentsMacroDataQuery(
		$contentId: ID!
		$first: Int = 250
		$offset: Int = 0
		$includeAttachmentActionContext: Boolean!
	) {
		singleContent(id: $contentId, status: ["current", "draft", "archived"]) {
			id
			type @include(if: $includeAttachmentActionContext)
			subType @include(if: $includeAttachmentActionContext)
			space @include(if: $includeAttachmentActionContext) {
				id
				key
			}
			operations {
				operation
			}
			attachments(first: $first, offset: $offset) {
				count
				pageInfo {
					hasNextPage
				}
				nodes {
					id
					title
					type
					extensions {
						key
						value
					}
					version {
						number
						when
						message
						by {
							... on KnownUser {
								accountId
								displayName
								profilePicture {
									path
								}
							}
							... on UnknownUser {
								accountId
								displayName
							}
						}
					}
					history {
						createdDate
						createdBy {
							... on KnownUser {
								accountId
								displayName
								profilePicture {
									path
								}
							}
							... on UnknownUser {
								accountId
								displayName
							}
						}
					}
					labels(first: 100) {
						nodes {
							id
							name
						}
					}
					operations {
						operation
					}
					links {
						download
					}
				}
			}
		}
	}
`;
